/*
    Created by Phat Hoang Pham
    phat@launchdeck.org
*/

import React, { PureComponent } from 'react';
import {
    Image,
    TouchableOpacity
} from 'react-native-web';
import PropTypes from 'prop-types';
import * as Animatable from 'react-native-animatable';

import GLOBAL from '../configs/config_global';

export class FloatingButton extends PureComponent {
    // region Props
    static propTypes = {
        initialPosition: PropTypes.oneOf(['bottom-left', 'top-left', 'bottom-right', 'top-right']),
        onPress: PropTypes.func,
        extraSpacingTop: PropTypes.number,
        extraSpacingBottom: PropTypes.number,
        buttonSize: PropTypes.number,
        buttonColor: PropTypes.string,
        icon: PropTypes.any,
        iconSize: PropTypes.number,
        elevation: PropTypes.number
    };

    static defaultProps = {
        initialPosition: 'bottom-right',
        onPress: () => {},
        extraSpacingTop: 0,
        extraSpacingBottom: 0,
        buttonSize: 64,
        buttonColor: GLOBAL.COLOR.BASIC.BLACK_TWO,
        icon: require('../images/iconLinePlus.png'),
        iconSize: 24,
        elevation: 4
    };
    // endregion

    // region Constructor
    defaultSpacing = 24;
    positionStyle = {
        'bottom-right': { bottom: this.defaultSpacing, right: this.defaultSpacing },
        'top-right': { top: this.defaultSpacing, right: this.defaultSpacing },
        'bottom-left': { bottom: this.defaultSpacing, left: this.defaultSpacing },
        'top-left': { top: this.defaultSpacing, left: this.defaultSpacing }
    };
    // endregion

    // region MAIN RENDER FUNCTION
    render() {
        const {
            onPress,
            initialPosition,
            extraSpacingTop,
            extraSpacingBottom,
            buttonSize,
            buttonColor,
            icon,
            iconSize
        } = this.props;

        return(
            <TouchableOpacity
                onPress={onPress}
                style={[{ position: 'absolute', zIndex: 100 }, this.positionStyle[initialPosition], { marginTop: extraSpacingTop, marginBottom: extraSpacingBottom }]}>
                <Animatable.View
                    animation={'fadeInUp'}
                    duration={600}
                    style={[
                        {
                            width: buttonSize, height: buttonSize, borderRadius: buttonSize / 2,
                            alignItems: 'center', justifyContent: 'center', backgroundColor: buttonColor
                        }
                    ]}>
                    <Image
                        source={icon}
                        style={{ width: iconSize, height: iconSize, tintColor: 'white' }}
                        resizeMode={'contain'}
                    />
                </Animatable.View>
            </TouchableOpacity>
        );
    }
    // endregion
}
